/** Breadcrumb / audit id for MT-QC-TASK-001. */
export const QC_TASK_PAGE_ID = 'MT-QC-TASK-001';

/** Tab keys stored in the URL and passed to the table toolbar. */
export const QC_TASK_TABS = /** @type {const} */ ({
  NEW: 'NEW',
  SAVE_FOR_LATER: 'SAVE_FOR_LATER',
  SUBMITTED: 'SUBMITTED',
});
